import { render } from "./FilterBlock.vue?vue&type=template&id=136eb6d0"
import script from "./FilterBlock.vue?vue&type=script&lang=js"
export * from "./FilterBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__